var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLittleLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 5,
    viewBox: "0 0 3 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14413_637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.84737 2.1254L0.742105 0L0 0.749203L1.73158 2.5L0 4.2508L0.742105 5L2.84737 2.8746C3.05263 2.66738 3.05263 2.33262 2.84737 2.1254Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14413_637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleLeftChevron);
export default __webpack_public_path__ + "static/media/littleLeftChevron.201a9f53402aed8b0e38f388e3273af7.svg";
export { ForwardRef as ReactComponent };